import { LockFilled } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';

interface StickyPayButtonProps {
  loading: boolean;
  disabled: boolean;
  currencySymbol?: string;
  grandTotal?: string | number;
}

const StickyPayButton: React.FC<StickyPayButtonProps> = ({
  loading,
  disabled,
  currencySymbol = '₹',
  grandTotal = '0',
}) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-grayZl-925 border-t border-grayZl-850 px-5 py-4 flex items-center justify-between gap-4 md:hidden shadow-[0_-8px_24px_rgba(0,0,0,0.4)]">
      <div className="flex flex-col">
        <span className="text-gray-400 text-xs uppercase tracking-wider font-medium">To Pay</span>
        <span className="text-white text-lg font-medium">
          {currencySymbol} {grandTotal}
        </span>
      </div>
      <div className="flex-1 max-w-[200px]">
        <Button
          loading={loading}
          disabled={disabled}
          className="w-full"
          size="large"
          icon={<LockFilled />}
          type="primary"
          htmlType="submit"
        >
          Proceed to Pay
        </Button>
      </div>
    </div>
  );
};

export default StickyPayButton;
